import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextContentEl = () => {
    return (
        <HighlightedText
            text="ΑΠΑΙΤΗΣΤΕ ΤΟ ΜΠΟΝΟΥΣ ΣΑΣ μπόνους 325% + 400 δωρεάν περιστροφές"
            highlights={[{ word: '325%' }, { word: '400' }]}
            breakAfterWords={['ΑΠΑΙΤΗΣΤΕ', 'ΣΑΣ', '325%', 'δωρεάν']}
            className={styles.text_content}
        />
    )
}
